import React from 'react';
import { HeroCarousel } from '../components/HeroCarousel';
import { HeroAtna } from '../components/HeroAtna';
import { QuickAccess } from '../components/QuickAccess';
import { News } from '../components/News';
import { Events } from '../components/Events';
interface AccueilProps {
  showEvents?: boolean;
}
export function Accueil({
  showEvents = true
}: AccueilProps) {
  return <main data-id="element-2724" data-mp="n44t3pb51bex">
      <HeroCarousel data-id="element-2725" data-mp="n4o2ghmq2rhc" />
      <div className="bg-white px-5 pt-6 lg:hidden" data-id="element-2726" data-mp="n566i0fmm9zt">
        <HeroAtna data-id="element-2727" data-mp="n1s813a32kxn" />
      </div>
      <QuickAccess data-id="element-2728" data-mp="i4sa5fne0ohm" />
      <News data-id="element-2729" data-mp="i4a5pvqkn3ym" />
      {showEvents && <Events data-id="element-2730" data-mp="i74pdl1rgkqz" />}
    </main>;
}